import { store } from '@betacrew/jars-flux';
import { QBO_LOADING_STATES } from '../constants';

export const componentKey = "QBO_SWITCH";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setQboAuthorizationUrl: (state, action) => {
            state.qboAuthorizationUrl = action.payload;
        },
        setBusinessList: (state, action) => {
            state.businessList = action.payload;
        },
        setChartOfAccounts: (state, action) => {
            state.chartOfAccounts = action.payload;
        },
        setFormBoxLabels: (state, action) => {
            state.formBoxLabels = action.payload;
        },
        setFormAndTaxYearList: (state, action) => {
            state.formAndTaxYearList = action.payload;
        },
        setImportData: (state, action) => {
            state.importData = action.payload;
        },
        setFormSettings: (state, action) => {
            state.formSettings = action.payload;
        },
        setIsImportDataGridViewLoaded: (state, action) => {
            state.isImportDataGridViewLoaded = action.payload;
        },
    },
    initialReducerState: {
        qboAuthorizationUrl: '',
        businessList: [],
        chartOfAccounts: [],
        formBoxLabels: {},
        formAndTaxYearList: {},
        importData: null,
        formSettings: null,
        isImportDataGridViewLoaded: false,
        loadingState: { state: QBO_LOADING_STATES.PRE_LOADING },
    }
});

export const { setQboAuthorizationUrl, setBusinessList, setChartOfAccounts, setFormBoxLabels, setFormAndTaxYearList, setImportData, setFormSettings,
    setIsImportDataGridViewLoaded, setLoadingState } = actions;